'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = function () {
  function Ajax() {
    _classCallCheck(this, Ajax);
  }

  _createClass(Ajax, [{
    key: 'generateCallbackFunction',
    value: function generateCallbackFunction() {
      return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
    }
  }, {
    key: 'httpRequest',
    value: function httpRequest() {
      return new XMLHttpRequest();
    }
  }, {
    key: 'jsonp',
    value: function jsonp(url, callback) {
      var callbackFunction = this.generateCallbackFunction();

      window[callbackFunction] = function (data) {
        callback(data);
      };

      var src = '' + url + (url.indexOf('?') !== -1 ? '&' : '?') + 'callback=' + callbackFunction;
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, {
    key: 'send',
    value: function send(url, options, method) {
      var httpRequest = this.httpRequest();
      var opts = _extends({
        callback: _utils.noop,
        errorCallback: _utils.noop
      }, options);

      httpRequest.open(method, url);

      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === 4) {
          var isSuccess = httpRequest.status >= 200 && httpRequest.status < 300 || httpRequest.status === 304;

          try {
            var data = JSON.parse(httpRequest.responseText);

            if (isSuccess) {
              opts.callback(data);
            } else {
              opts.errorCallback(data);
            }
          } catch (error) {
            opts.errorCallback(httpRequest);
          }
        }
      };

      if (opts.data && _typeof(opts.data) === 'object') {
        httpRequest.setRequestHeader('Content-type', 'application/json');
        httpRequest.send(JSON.stringify(opts.data));
      } else {
        httpRequest.send();
      }
    }
  }, {
    key: 'get',
    value: function get(url, options) {
      this.send(url, options, 'GET');
    }
  }, {
    key: 'post',
    value: function post(url, options) {
      this.send(url, options, 'POST');
    }
  }]);

  return Ajax;
}();

exports.default = new Ajax();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/Ajax.js
// module id = 7
// module chunks = 0 1 2